import { StyleSheet } from 'react-native';
import { ticketColors, ticketFonts } from '../theme/public-api';

/**
 * Filas del overlay “Más” — skin Square (tile + ruleSoft).
 * El chrome sheet/dialog vive en ticketChrome + TicketMoreActionsSheet.
 */
export const ticketMoreActions = StyleSheet.create({
  sheet: {
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    borderTopWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingTop: 8,
    overflow: 'hidden',
    zIndex: 1,
  },
  scrollContent: {
    paddingHorizontal: 16,
    paddingBottom: 8,
    gap: 8,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 12,
    gap: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
  },
  rowDisabled: {
    opacity: 0.5,
  },
  iconWrap: {
    width: 36,
    height: 36,
    borderRadius: 10,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textCol: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  rowLabel: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  rowHint: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
});
